export const SITE_URL = 'https://vernoweb.com';

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'Verno Web',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.svg`,
    foundingDate: '2024',
    sameAs: [
      'https://www.linkedin.com/company/vernoweb',
      'https://www.instagram.com/vernoweb/',
    ],
  };
}

export function getLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#localbusiness`,
    name: 'Verno Web',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.svg`,
    email: 'nate@vernoweb.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Seattle',
      addressRegion: 'WA',
      addressCountry: 'US',
    },
    foundingDate: '2024',
    parentOrganization: { '@id': `${SITE_URL}/#organization` },
    sameAs: [
      'https://www.linkedin.com/company/vernoweb',
      'https://www.instagram.com/vernoweb/',
    ],
  };
}

export function getPersonSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': `${SITE_URL}/#nate-chambers`,
    name: 'Nate Chambers',
    jobTitle: 'Founder',
    url: `${SITE_URL}/about`,
    worksFor: { '@id': `${SITE_URL}/#organization` },
    sameAs: [
      'https://www.instagram.com/vernoweb/',
    ],
  };
}

export function getBreadcrumbSchema(
  items: Array<{ name: string; path: string }>,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function getServiceSchema(options: {
  serviceType: string;
  description: string;
  urlPath: string;
  areaServed?: string;
}) {
  const url = `${SITE_URL}${options.urlPath}`;

  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: options.serviceType,
    description: options.description,
    url,
    areaServed: options.areaServed ?? 'United States',
    provider: { '@id': `${SITE_URL}/#organization` },
    offers: { '@type': 'Offer', url: `${SITE_URL}/pricing` },
  };
}

export function getBlogPostingSchema(options: {
  headline: string;
  description: string;
  urlPath: string;
  datePublished: string;
  dateModified?: string;
  imageUrl?: string;
}) {
  const url = `${SITE_URL}${options.urlPath}`;
  const image = options.imageUrl ?? `${SITE_URL}/og-image.png`;

  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: options.headline,
    description: options.description,
    mainEntityOfPage: url,
    url,
    datePublished: options.datePublished,
    dateModified: options.dateModified ?? options.datePublished,
    image: [image],
    author: { '@id': `${SITE_URL}/#nate-chambers` },
    publisher: { '@id': `${SITE_URL}/#organization` },
  };
}
